var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "qr-code-details"
  }, [_c('div', {
    staticClass: "qr-content"
  }, [_c('v-row', {
    staticClass: "content mx-0 mt-5"
  }, [_c('v-col', {
    staticClass: "flex-grow-0 preview-col pr-0 ml-3",
    attrs: {
      "align-self": "center"
    }
  }, [_c('div', {
    staticClass: "qr-preview d-flex flex-column justify-center"
  }, [_c('div', {
    staticClass: "qr-preview-ctn"
  }, [_c('img', {
    staticClass: "qr",
    attrs: {
      "src": _vm.previewUrl()
    }
  }), _vm.form.image ? _c('img', {
    staticClass: "logo",
    style: {
      backgroundColor: _vm.form.background
    },
    attrs: {
      "src": _vm.toDataUrl(_vm.form.image)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "mt-auto mb-2"
  }), _c('v-btn', {
    staticClass: "w-100",
    attrs: {
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.download
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-download")]), _vm._v(" " + _vm._s(_vm.$t('download')) + " ")], 1)], 1)]), _c('v-col', [_c('div', {
    staticClass: "d-flex flex-column color-inputs-ctn ml-3"
  }, [_c('v-form', {
    ref: "qrForm"
  }, [_c('div', {
    staticClass: "d-flex flex-row align-center"
  }, [_c('div', {
    staticClass: "flex-shrink-1"
  }, [_c('div', {
    staticClass: "label font-weight-bold pb-1"
  }, [_vm._v(_vm._s(_vm.$t('qr_color')))]), _c('color-input', {
    attrs: {
      "color": _vm.form.color
    },
    on: {
      "update:color": function ($event) {
        return _vm.$set(_vm.form, "color", $event);
      }
    }
  })], 1), _c('div', {
    staticClass: "ml-5"
  }, [_c('div', {
    staticClass: "label font-weight-bold pb-1"
  }, [_vm._v(_vm._s(_vm.$t('background_color')))]), _c('color-input', {
    attrs: {
      "color": _vm.form.background
    },
    on: {
      "update:color": function ($event) {
        return _vm.$set(_vm.form, "background", $event);
      }
    }
  })], 1)])]), _vm.hasContrastIssue ? _c('div', {
    staticClass: "color-error pt-5 d-flex"
  }, [_c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "color": "red"
    }
  }, [_vm._v("mdi-alert")]), _c('div', {
    staticClass: "font-weight-bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('qr_contrast_warning'))
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "mt-4"
  }, [_c('ImageCropper', {
    staticClass: "add-icon-btn",
    attrs: {
      "ratio": 1,
      "label": _vm.$t('upload_logo'),
      "input-key": "qr-logo",
      "show-select-dialog": false
    },
    on: {
      "image-selected": _vm.onImageSelect
    }
  }), _vm.form.image ? _c('v-btn', {
    staticClass: "mt-3 add-icon-btn",
    attrs: {
      "outlined": "",
      "text": ""
    },
    on: {
      "click": _vm.deleteLogo
    }
  }, [_vm._v(_vm._s(_vm.$t('remove_logo')))]) : _vm._e()], 1)], 1)])], 1), _c('div', {
    staticClass: "mt-5 ml-3 mr-3"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "label font-weight-bold pb-1"
  }, [_vm._v(_vm._s(_vm.$t('qr_image_format')))]), _c('div', {
    staticClass: "mt-2"
  }, _vm._l(_vm.formats, function (format) {
    return _c('span', {
      key: format,
      staticClass: "pill uppercase font-weight-regular mr-2 mb-2",
      class: {
        'selected': format === _vm.form.format
      },
      on: {
        "click": function ($event) {
          return _vm.selectFormat(format);
        }
      }
    }, [_vm._v(" " + _vm._s(format) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "label font-weight-bold pb-1"
  }, [_vm._v(_vm._s(_vm.$t('create_file_name')))]), _c('div', {
    staticClass: "hint"
  }, [_vm._v(" " + _vm._s(_vm.$t('naming_convention_hint')) + " ")]), _c('div', {
    staticClass: "mt-2"
  }, [_vm._l(_vm.generalFields, function (field) {
    return _c('span', {
      key: `general-field-${field}`,
      staticClass: "pill font-weight-regular mr-2 mb-2",
      class: {
        'selected': _vm.isFileNameFieldSelected(field)
      },
      on: {
        "click": function ($event) {
          return _vm.toggleFileNameFields(field);
        }
      }
    }, [_vm._v(_vm._s(field))]);
  }), _vm._l(_vm.gs1Fields, function (field) {
    return _c('span', {
      key: `gs1-field-${field}`,
      staticClass: "pill font-weight-regular mr-2 mb-2",
      class: {
        'selected': _vm.isFileNameFieldSelected(field)
      },
      on: {
        "click": function ($event) {
          return _vm.toggleFileNameFields(field);
        }
      }
    }, [_vm._v(_vm._s(field))]);
  })], 2), _c('v-text-field', {
    ref: "filename",
    staticClass: "mt-3 filename-input",
    attrs: {
      "label": _vm.$t('file_name'),
      "hide-details": "auto",
      "outlined": "",
      "small": "",
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('span', {
          staticClass: "pt-1"
        }, [_vm._v(" ." + _vm._s(_vm.form.format) + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.filename,
      callback: function ($$v) {
        _vm.$set(_vm.form, "filename", $$v);
      },
      expression: "form.filename"
    }
  })], 1)])])], 1), _c('div', {
    staticClass: "actions-ctn"
  }, [_c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.download
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-download")]), _vm._v(" " + _vm._s(_vm.$t('download')) + " ")], 1), _c('v-btn', {
    staticClass: "save-btn",
    attrs: {
      "loading": _vm.loading,
      "color": "primary",
      "raised": ""
    },
    on: {
      "click": function ($event) {
        return _vm.save();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }